
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.UndeliverableStop = {

  template() {
    return {
      items: [{
        attributes: {
          "id": 'UndeliverableStopEvent'
        },
        items: [
          {
            attributes: {
              class: 'control-group',
              id: 'undeliverableReasonsContainer'
            }
          },
          {
            items: [
              {
                attributes: {
                  class: 'control-group',
                  id: 'plannedSizeContainer'
                }
              },
              {
                attributes: {
                  class: 'control-group',
                  id: 'minimumPlannedSizeContainer'
                }
              },
            ]
          }
        ]
      }]
    };
  },

  renderFields() {
    //Create Monet field
    const undeliverableReasons = new Monet.UI.Fields.Render({
      name: 'undeliverableReasons',
      label: 'event.undeliverable.reasons',
      mandatory: false,
      type: 'LOOKUP_LIST',
      lookupEntity: 'UndeliverableCode',
      lookupEntityColumn: 'description'
    }, 'Event').render();

    const plannedSize = new Monet.UI.Fields.Render({
      name: 'plannedSize',
      label: Monet.I18n.getResourcesByKey('event.UndeliverableStop.plannedSize', ' '),
      mandatory: false,
      defaultValue: '',
      type: 'PICKLIST',
      fieldDomains: [
        { description: '', value: '' },
        { description: Monet.Session.Configurations.size1Alias, value: 'plannedSize1', id: 'plannedSize1' },
        { description: Monet.Session.Configurations.size2Alias, value: 'plannedSize2', id: 'plannedSize2' },
        { description: Monet.Session.Configurations.size3Alias, value: 'plannedSize3', id: 'plannedSize3' }
      ]
    }).render();

    const minimumPlannedSize = new Monet.UI.Fields.Render({
      name: 'minimumPlannedSize',
      label: Monet.I18n.getResourcesByKey('event.UndeliverableStop.minimumPlannedSize', ' '),
      mandatory: false,
      defaultValue: '0.00',
      type: 'DECIMAL',
    }).render();

    minimumPlannedSize.disable();

    minimumPlannedSize.updateField = () => {
      let selectedSize = plannedSize.input.selectedOptions[0].innerText;
      if (selectedSize) {
        selectedSize = `(${selectedSize})`;
        minimumPlannedSize.enable();
      } else {
        selectedSize = ' ';
        minimumPlannedSize.setValue('0.00');
        minimumPlannedSize.disable();
      }
      minimumPlannedSize.setTextLabel(Monet.I18n.getResourcesByKey('event.UndeliverableStop.minimumPlannedSize', selectedSize));
    }

    plannedSize.removeOption(0);
    plannedSize.input.addEventListener('change', minimumPlannedSize.updateField);

    undeliverableReasons.customCriteriaChain = [{
      attr: "type",
      neq: "L"
    }];

    Greenmile.Checks.EventCheck.UndeliverableStop.fields = { undeliverableReasons, plannedSize, minimumPlannedSize };

    //Append field to DOM
    const undeliverableReasonsContainer = document.querySelector('#UndeliverableStopEvent #undeliverableReasonsContainer');
    undeliverableReasonsContainer.appendChild(undeliverableReasons.rootEl);

    const plannedSizeContainer = document.querySelector('#UndeliverableStopEvent #plannedSizeContainer');
    plannedSizeContainer.appendChild(plannedSize.rootEl);

    const minimumPlannedSizeContainer = document.querySelector('#UndeliverableStopEvent #minimumPlannedSizeContainer');
    minimumPlannedSizeContainer.appendChild(minimumPlannedSize.rootEl);
  },

  assignParameter(jsonParam) {
    Greenmile.Checks.EventCheck.UndeliverableStop.renderFields();
    const fields = Greenmile.Checks.EventCheck.UndeliverableStop.fields;
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      fields.undeliverableReasons.setValue(jsonParam.reasons);
      if (jsonParam.minimumPlanned) {
        const plannedSize = Object.keys(jsonParam.minimumPlanned)[0];
        fields.plannedSize.setValue(plannedSize);
        fields.minimumPlannedSize.setValue(jsonParam.minimumPlanned[plannedSize]);
        fields.minimumPlannedSize.updateField();
      }
    }
  },

  retrieveParameter() {
    const fields = Greenmile.Checks.EventCheck.UndeliverableStop.fields;
    let minimumPlanned = null;
    if(fields.plannedSize.getValue()) {
      minimumPlanned = {
        [fields.plannedSize.getValue()]: fields.minimumPlannedSize.getValue()
      };
    }
    return JSON.stringify({
      reasons: fields.undeliverableReasons.getFullValue().map(field => field.id.toString()),
      minimumPlanned
    });
  }

};
